// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Square__pc_only___1_Te7","sp_only":"Square__sp_only___aNjBG","container":"Square__container___2MdT6"};